var _style, _path, _path2, _path3, _path4, _path5, _path6, _defs, _g, _circle, _circle2, _circle3, _circle4, _circle5;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgEmpty(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "OBJECTS",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 200 170",
    style: {
      enableBackground: "new 0 0 200 170"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:#E3EBFD;}\r\n\t.st1{fill:#ADCDF7;}\r\n\t.st2{fill:#FFFFFF;}\r\n\t.st3{fill:#91B8E2;}\r\n\t.st4{clip-path:url(#SVGID_2_);}\r\n\t.st5{fill:#E5EAF7;}\r\n\t.st6{fill:#A9CAFF;}\r\n")), /*#__PURE__*/React.createElement("g", null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M72.85,32.56c1.82-3.9,4.14-7.66,7.04-11.22c22.81-27.91,67.63-25.55,93.92-3.06 c29.15,24.95,26.45,66.93,25.86,74.11c-2.07,24.96-15.03,65.58-44.83,73.86c-13.85,3.84-27.06-0.48-38.58-8.5 c-9.1-6.33-21.1-5.74-29.79,1.68c-3.29,2.81-6.95,5.18-11.02,6.86c-9.21,3.8-17.41,2.79-20.96,2.3 C26.79,164.8-0.25,133.28,0,103.81C0.29,69.99,36.49,44.05,72.85,32.56z"
  })), /*#__PURE__*/React.createElement("g", null, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M38.88,80.83l57.45-42.62c2.35-1.74,5.56-1.73,7.9,0.03l56.58,42.59H38.88z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M154.63,149.15H45.05c-4.46,0-8.08-3.62-8.08-8.08V86.36c0-4.46,3.62-8.08,8.08-8.08h109.58 c4.46,0,8.08,3.62,8.08,8.08v54.71C162.71,145.53,159.1,149.15,154.63,149.15z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M157.04,77.27l0,6.46l-51.07,30.05l-1.72-1.05c-2.7-1.65-6.09-1.64-8.78,0.03l-1.71,1.07L42.33,83.74l0-6.46 H157.04z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M158.28,145.22l-52.32-30.97l-1.72-1.05c-2.7-1.65-6.09-1.64-8.78,0.03l-1.71,1.07l-51.42,30.93l48.7-33.02 l4.28-2.99c2.96-2.21,7.02-2.21,9.98,0l3.77,2.63L158.28,145.22z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M146.07,53.83H53.29c-6.06,0-10.96,4.91-10.96,10.96v10.56c0,6.06,4.91,10.96,10.96,10.96h92.78 c6.06,0,10.96-4.91,10.96-10.96V64.8C157.04,58.74,152.13,53.83,146.07,53.83z"
  })), /*#__PURE__*/React.createElement("g", null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_1_",
    d: "M157.04,62.41l0,21.33l-51.07,30.05l-1.72-1.05c-2.7-1.65-6.09-1.64-8.78,0.03l-1.71,1.07L42.33,83.74 l0-21.33H157.04z"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_2_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_1_",
    style: {
      overflow: "visible"
    }
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "st4"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M146.82,70.5h-95.8c-1.09,0-1.98-0.89-1.98-1.98v-1.91c0-1.09,0.89-1.98,1.98-1.98h95.8 c1.09,0,1.98,0.89,1.98,1.98v1.91C148.8,69.61,147.91,70.5,146.82,70.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M146.82,88.2h-95.8c-1.09,0-1.98-0.89-1.98-1.98v-1.91c0-1.09,0.89-1.98,1.98-1.98h95.8 c1.09,0,1.98,0.89,1.98,1.98v1.91C148.8,87.31,147.91,88.2,146.82,88.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M146.82,105.91h-95.8c-1.09,0-1.98-0.89-1.98-1.98v-1.91c0-1.09,0.89-1.98,1.98-1.98h95.8 c1.09,0,1.98,0.89,1.98,1.98v1.91C148.8,105.02,147.91,105.91,146.82,105.91z"
  }))))), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "st6",
    cx: 132.7,
    cy: 29.54,
    r: 4.8
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    className: "st6",
    cx: 22.82,
    cy: 78.81,
    r: 2.99
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    className: "st6",
    cx: 61.63,
    cy: 34.05,
    r: 1.99
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    className: "st6",
    cx: 73.95,
    cy: 21.53,
    r: 4.06
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    className: "st6",
    cx: 177.1,
    cy: 60.13,
    r: 3.26
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmpty);
export default __webpack_public_path__ + "static/media/empty.6057fb0dc9ac8d910b53e29293378930.svg";
export { ForwardRef as ReactComponent };